export default __webpack_public_path__ + "static/Hepatofelin-tablet-ddf493ebd74c007439145beb40d14bf6.jpg";